import { render, staticRenderFns } from "./personFlow.vue?vue&type=template&id=390f70d8&scoped=true&"
import script from "./personFlow.vue?vue&type=script&lang=js&"
export * from "./personFlow.vue?vue&type=script&lang=js&"
import style0 from "./personFlow.vue?vue&type=style&index=0&id=390f70d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390f70d8",
  null
  
)

export default component.exports